/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.primary-menu-parent' ).on( 'toggleAfter', ( event ) => {
        if ( !window.matchMedia( '(min-width: 1024px)' ).matches ) {
          $( event.target ).next().slideToggle();
        }
      } );

      // Switch data-src to source on any image with class lazy
      const switchImageSrc = ( target ) => {
        const images = $( target ).find( '.ll-lazy' );

        images.each( function( index, element ) {
          if ( $( element ).hasClass( 'll-lazy' ) ) {
            const source = $( element ).attr( 'data-src' );
            $( element ).attr( 'src', source );
            $( element ).removeClass( 'll-lazy' );
          }
        } );
      };

      // add event listener to switch any images with custom lazy load
      $( '.primary-menu-parent' ).on( 'toggleAfter', ( event ) => {
        const target = $( event.target ).attr( 'data-lazy' );
        // load images
        switchImageSrc( target );
      } );

      function debounce( func, timeout = 300 ) {
        let timer;
        return ( ...args ) => {
          clearTimeout( timer );
          timer = setTimeout( () => {
            func.apply( this, args );
          }, timeout );
        };
      }

      $( window ).on( 'resize', debounce( function() {
        if ( $( '.alert-banner' ).length !== 0 && !$( '.alert-banner' ).hasClass( 'hidden' ) && !$( '.navbar' ).hasClass( 'is-scrolled' ) ) {
          setAlertBanHeight( $( '.alert-banner__content' ).outerHeight() );
        }
        if ( $( '.guest-resource__nav' ).length !== 0 ) {
          if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
            setGuestBanHeight( $( '.guest-resource__nav-content' ).outerHeight() );
          }
        }
        $( document ).trigger( 'updatedWindow' );
      } ) );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      function handleMobileChange( event ) {
        // if ( event.matches && $( '.logo-header__large' ).hasClass( 'logo-header__large' ) ) {
        //   const source = $( '.logo-header__large' ).attr( 'data-src' );
        //   $( '.logo-header__large' ).attr( 'src', source );
        //   $( '.logo-header__large' ).removeClass( 'll-lazy' );
        // }

        if ( $( '.navbar' ).length > 0 ) {
          // click any buttons that have open class to reset easy toggle
          $( 'button.primary-menu-parent.is-open' ).each( function( index, element ) {
            $( element ).trigger( 'click' );
          } );
          $( '.navbar-toggle.is-open' ).each( function( index, element ) {
            $( element ).trigger( 'click' );
            // remove any inline styles
            $( element ).next().get( 0 ).style.removeProperty( 'display' );
          } );
        }

        // remove styling added by scroll animation
        $( '.navbar' ).removeClass( 'is-scrolled' );
        $( ':root' ).get( 0 ).style.removeProperty( '--primaryNavHeight' );
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 1024px)' );
      mobileSize.addEventListener( 'change', handleMobileChange );

      // add custom file upload button
      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).on( 'change', function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload span' );
          $( theInput ).text( filename );
        } );
      }

      // lazy loads background images in css
      const lazyBackgrounds = [].slice.call( document.querySelectorAll( '.lazy-background' ) );

      if ( 'IntersectionObserver' in window ) {
        const lazyBackgroundObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( entry ) {
            if ( entry.isIntersecting ) {
              entry.target.classList.add( 'is-visible' );
              lazyBackgroundObserver.unobserve( entry.target );
            }
          } );
        } );

        lazyBackgrounds.forEach( function( lazyBackground ) {
          lazyBackgroundObserver.observe( lazyBackground );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
